export default "__VITE_ASSET__99c0a504__"